import React, { useEffect, useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../Login/AuthContext";

const ListaUsuarios = () => {
  const [usuarios, setUsuarios] = useState([]);
  const [cargando, setCargando] = useState(true);
  const { token, logout } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    cargarUsuarios();
  }, [token]);

  const cargarUsuarios = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/usuarios`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setUsuarios(response.data);
    } catch (error) {
      if (error.response?.status === 401 || error.response?.status === 403) {
        logout();
        navigate("/login");
      } else {
        Swal.fire({ icon: "error", title: "Error", text: "No se pudieron cargar los usuarios" });
      }
    } finally {
      setCargando(false);
    }
  };

  if (cargando) {
    return (
      <p className="text-center text-gray-600 mt-10">Cargando usuarios...</p>
    );
  }

  return (
    <div className="p-4 md:p-6 max-w-5xl mx-auto">
      <h2 className="text-xl md:text-2xl font-bold text-black mb-6">Usuarios registrados</h2>

      {usuarios.length === 0 ? (
        <p className="text-gray-500">No hay usuarios registrados.</p>
      ) : (
        <div className="overflow-x-auto rounded-xl shadow border border-gray-300">
          <table className="w-full min-w-[760px] text-sm">
            <thead className="bg-gray-200 text-black">
              <tr>
                <th className="p-3 text-left">ID</th>
                <th className="p-3 text-left">Username</th>
                <th className="p-3 text-left">Nombre</th>
                <th className="p-3 text-left">Email</th>
                <th className="p-3 text-left">Teléfono</th>
                <th className="p-3 text-left">Rol</th>
              </tr>
            </thead>
            <tbody>
              {usuarios.map((u, i) => (
                <tr key={u.id} className={i % 2 === 0 ? "bg-white" : "bg-gray-50"}>
                  <td className="p-3 text-gray-500">{u.id}</td>
                  <td className="p-3 font-medium text-gray-800">{u.username}</td>
                  <td className="p-3 text-gray-700">{u.nombre || "-"} {u.apellido || ""}</td>
                  <td className="p-3 text-gray-600">{u.email || "-"}</td>
                  <td className="p-3 text-gray-600">{u.telefono || "-"}</td>
                  <td className="p-3">
                    <span className={`px-2 py-1 rounded-full text-xs font-bold ${
                      u.rol === "admin" ? "bg-purple-100 text-purple-700" : "bg-gray-200 text-gray-800"
                    }`}>
                      {u.rol}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default ListaUsuarios;
